import Checkbox from '../../../../Checkbox/Checkbox';
import { Truncate } from '../../../../Truncate/Truncate';
import React from 'react'
import LoadingSpinner from '../../common/LoadingSpinner';

interface FilterDropdownProps {
  data: any;
  field: string;
  setSelectedItems: (items: string[]) => void;
  selectedItems: string[];
  loading?: boolean;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({ data, field, selectedItems, setSelectedItems, loading }) => {

  const handleCheckboxChange = (event: any, item: any) => {
    const updatedSelectedItems = event.target.checked
      ? [...selectedItems, item.id]
      : selectedItems.filter((selectedItem) => selectedItem !== item.id);

    setSelectedItems(updatedSelectedItems);
  };

  return (
    <div className="FilterDropdown">
      <div className="FilterDropdown__content">
        {data.length > 0 ? (
          <>
            <div className="FilterDropdown__checkbox-container">
              {data.map((item: any, index: number) => {
                const isChecked = selectedItems.includes(item.id);
                return (
                  <Checkbox
                    key={index}
                    label={
                      <>
                        <Truncate
                          isResponsive
                          maxChar={35}
                          testId={`truncate-${field}-${item.id}`}
                        >
                          {item.name}
                        </Truncate>
                        {item?.fallback_locale === null ? <span className='FilterDropdown__fallback-locale-text'>M</span> : null}
                      </>
                    }
                    onChange={(event) => handleCheckboxChange(event, item)}
                    checked={isChecked}
                  />
                );
              })}
            </div>
            {loading && (
              <div className="spinner-container">
                <LoadingSpinner size={30} color="grey" />
              </div>
            )}
          </>
        ) : (
          loading && (
            <div className="spinner-container">
              <LoadingSpinner size={30} color="grey" />
            </div>
          )
        )}
      </div>
    </div>
  );



}

export default FilterDropdown